import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { SvgSpacesMastheadFile, SvgSpacesMastheadExternalServer, SvgSpacesMediumFileCertified, SvgSpacesMediumFile, SvgSpacesMediumExternalServerCertified, SvgSpacesMediumExternalServer } from '../../../../../gen-src/icons';
import { DatabaseIconFragment } from '../../../../../gen-src/queries';
import { messageForConnectionType } from '../displayUtils/MessageUtils';
import { placePageIconClass } from '../style/PlaceStyles';
import { assertUnreachable } from '../utils/TypescriptHelpers';

// Adapted from DatabaseIconFragment.__typename
export type DatabaseTypename = 'DatabaseServer' | 'CloudFile' | 'File' | 'WebDataConnector';

export type DatabaseIconSansNote = Omit<DatabaseIconFragment, 'certificationNote'>;

export interface DatabaseIconProps {
  readonly database: DatabaseIconSansNote;
}

export function DatabaseMastheadIcon(props: DatabaseIconProps): JSX.Element | null {
  switch (props.database.__typename) {
    case 'CloudFile':
    case 'File':
      return <SvgSpacesMastheadFile className={placePageIconClass} />;
    case 'DatabaseServer':
    case 'WebDataConnector':
      return <SvgSpacesMastheadExternalServer className={placePageIconClass} />;
    default:
      assertUnreachable(props.database.__typename);
      return null;
  }
}

export function DatabaseMediumIcon(props: DatabaseIconProps): JSX.Element | null {
  switch (props.database.__typename) {
    case 'CloudFile':
    case 'File':
      return props.database.isCertified ? <SvgSpacesMediumFileCertified /> : <SvgSpacesMediumFile />;
    case 'DatabaseServer':
    case 'WebDataConnector':
      return props.database.isCertified ? <SvgSpacesMediumExternalServerCertified /> : <SvgSpacesMediumExternalServer />;
    default:
      assertUnreachable(props.database.__typename);
      return null;
  }
}

export function getDatabaseIconTooltip(database: DatabaseIconSansNote): string {
  const friendlyConnectionTypeName = messageForConnectionType(database.connectionType);
  switch (database.__typename) {
    case 'CloudFile':
    case 'File':
      return database.connectionType ?
        Messages.FileWithType({ type: friendlyConnectionTypeName || '' })
        : Messages.PermissionsRequired();
    case 'DatabaseServer':
    case 'WebDataConnector':
      return database.connectionType ?
        Messages.DatabaseWithType({ type: friendlyConnectionTypeName || '' })
        : Messages.PermissionsRequired();
    default:
      assertUnreachable(database.__typename);
      return '';
  }
}
